import { render, staticRenderFns } from "./_BodyContentInputOtp.vue?vue&type=template&id=7a4cfbcf&scoped=true"
import script from "./_BodyContentInputOtp.vue?vue&type=script&lang=js"
export * from "./_BodyContentInputOtp.vue?vue&type=script&lang=js"
import style0 from "./_BodyContentInputOtp.vue?vue&type=style&index=0&id=7a4cfbcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cfbcf",
  null
  
)

export default component.exports